import {createContext} from 'react';
import { AlertMessage } from '../../components/alert/AlertComponent';


export const AlertContext = createContext<AlertMessage>({
    text: undefined,
    type: undefined,
    setAlert: () => undefined
});